import styled from "styled-components";
import colours from "styles/colours";
import { fontWeights } from "styles/fonts";

export const ExpandButton = styled.button`
  background: none;
  border: none;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  margin-left: 5px;
  font-weight: ${fontWeights.bold};
  color: black;
  text-underline-offset: 4px;

  &:hover {
    color: ${colours.elexonBlue};
  }
`;
